import { render, staticRenderFns } from "./GallerySeriesAlbum.vue?vue&type=template&id=243fe35b&scoped=true&"
import script from "./GallerySeriesAlbum.vue?vue&type=script&lang=js&"
export * from "./GallerySeriesAlbum.vue?vue&type=script&lang=js&"
import style0 from "./GallerySeriesAlbum.vue?vue&type=style&index=0&id=243fe35b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243fe35b",
  null
  
)

export default component.exports